import P2PDownload from './p2p';
import RequestAjax from './httpRequest'; //http请求模块
import sendVplayer from './staP2P'; //发送p2p统计的模块
import downloadConfig from './downloadConfig'; //下载配置模块
import template from './consoleInfo.tpl'; //todo待删除 测试dom模板
import container from './testInfoContainer.tpl'; //todo待删除 测试dom模板
import BrowserSupport from './browserSupport.js';
import canUseMse from './canUseMse.js';

let canUseObj = new canUseMse();
console.log(canUseObj.judgement());

function showPlaying(index) {
    let testInfoDom = document.getElementById('info-container');
    if (testInfoDom) {
        let [...playingDom] = testInfoDom.getElementsByClassName('playing');
        playingDom.forEach(dom => {
            dom.style.display = 'none';
        });
        if (testInfoDom.getElementsByTagName('li').length) {
            testInfoDom.getElementsByTagName('li')[index].getElementsByClassName('playing')[0].style.display = 'block';
        }
    }
    let video = document.getElementById('video');
    if (video && video.buffered && video.buffered.length) {
        let end = video.buffered.end(0);
        let bufferInfoDom = document.getElementById('buffer-info');
        bufferInfoDom.innerHTML = end;
    }
}
function updateTestInfo(that) {
    let testInfoDom = document.getElementById('info-container');
    if (testInfoDom) {
        let mDataBlockArray = that.mDataBlockArray;
        let sum = 0;
        let total = that.mSize;
        for (let i = 0, len = mDataBlockArray.length; i < len; i++) {
            let obj = mDataBlockArray[i];
            if (obj.P2PDataLength) {
                sum += obj.P2PDataLength;
            }
        }
        let shareRate = sum / total * 100;
        shareRate = shareRate.toFixed(2);
        document.getElementsByClassName('p2pshare-rate')[0].innerHTML = 'P2P分享率为：' + shareRate + '%';
        testInfoDom.innerHTML = template({ data: mDataBlockArray });
        getRate(that);
        showPlaying(that.playingIndex);
    }
}

function getRate(that) {
    let downloadInfoDom = document.getElementById('download-info');
    let sum = 0;
    let totalTemp = 0;
    let totalVdn = 0;
    let total = that.mSize;
    let mDataBlockArray = that.mDataBlockArray;
    for (let i = 0, len = mDataBlockArray.length; i < len; i++) {
        let obj = mDataBlockArray[i];
        if (obj.P2PDataLength) {
            sum += obj.P2PDataLength;
        }
        if (obj.mDataLength) {
            totalTemp += obj.mDataLength;
        }
    }
    totalVdn = totalTemp - sum;
    downloadInfoDom.innerHTML = `<span class="cdn">cdn下载量：${(totalVdn / 1024).toFixed(
        2,
    )}KB</span><span class="p2p">p2p下载量：${(sum / 1024).toFixed(2)}KB</span>`;
    return { cdn: totalVdn, p2p: sum };
}

function setTestContainer(t) {
    let testInfoDom = document.createElement('div');
    testInfoDom.id = 'ifeng-test-info-container';
    let browserSupport = new BrowserSupport();
    let info = browserSupport.get();
    testInfoDom.innerHTML = container({ s: info });
    document.querySelector('body').appendChild(testInfoDom);
    let containerDom = document.getElementById('ifeng-test-info-container');
    let cdnSpeedDom = document.getElementById('http-speed-number');
    let p2pSpeedDom = document.getElementById('p2p-speed-number');
    //画曲线的脚本
    let head = document.getElementsByTagName('head')[0];
    let js = document.createElement('script');
    let src = 'http://p3.ifengimg.com/a/2017/1120/smoothie.js';
    let smoothie;
    js.setAttribute('src', src);
    js.onload = js.onreadystatechange = function() {
        if (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete') {
            t.smoothie = smoothie = new SmoothieChart({
                grid: { strokeStyle: 'rgb(0, 0, 0)', fillStyle: 'rgb(0, 0, 0)' },
                labels: { fillStyle: 'rgb(0, 0, 0)', disabled: true },
            });
            smoothie.streamTo(document.getElementById('show-rate-box'));
            let line1 = (t.line1 = new TimeSeries());
            let line2 = (t.line2 = new TimeSeries());
            smoothie.addTimeSeries(line1, {
                strokeStyle: 'rgb(255, 0, 0)',
                fillStyle: 'rgba(255, 255, 255, 0)',
                lineWidth: 3,
            });
            smoothie.addTimeSeries(line2, {
                strokeStyle: 'rgb(0, 255, 0)',
                fillStyle: 'rgba(255, 255, 255, 0)',
                lineWidth: 3,
            });
            setInterval(function() {
                let temp = getRate(t);
                let rate = (temp.cdn - t.lastDownloadNum) / 1024;
                rate = rate.toFixed(2);
                line1.append(new Date().getTime(), rate);
                line2.append(new Date().getTime(), t.p2pRate);
                p2pSpeedDom.innerHTML = `<span> ${t.p2pRate.toFixed(2)} Kbps</span>`;
                t.p2pRate = 0;
                t.lastDownloadNum = temp.cdn;
                cdnSpeedDom.innerHTML = `<span> ${rate} Kbps</span>`;
            }, 1000);
        }
    };
    head.appendChild(js);
    $('#info-container')
        .on('mouseover', 'li', function() {
            $('.info-box').hide();
            $(this)
                .find('.info-box')
                .show();
        })
        .on('mouseout', 'li', function() {
            $('.info-box').hide();
        });
}

const bufferSlice = () => {
    // Uint8Array IE和safari不支持slice方法
    if (!Uint8Array.prototype.slice) {
        Uint8Array.prototype.slice = function(a, b) {
            var Uint8ArraySlice = new Uint8Array(this.buffer.slice(a, b));
            return Uint8ArraySlice;
        };
    }
};

class downloadModel {
    constructor({ showTestInfo = false }) {
        // url
        this.mURL = '';
        // 下载数据数组
        this.mDataBlockArray = [];
        // 还没下载完成的block id数组
        this.mNotDownloadBlockId = [];
        // 文件大小
        this.mSize = 0;
        // P2P下载数据Map
        this.mP2PDownloadMap = {};
        this.mP2PDownloadBlockMaxNum = 0;
        // 读取位置
        this.mReadPos = 0;
        // 第一块大小
        this.mFirstBlockSize = 0;
        // 是否正在VDN请求
        this.mVDNRequesting = false;
        // TrackServer服务器IP和端口
        this.mServerInfo = 'http://111.202.92.68:8081';
        // 返回数据回调函数（暂时取数据）
        this.mReturnDataCallback = null;
        // http请求
        this.httpRequest = new RequestAjax();
        // http请求的状态码
        this.HttpRequestResponse = this.httpRequest.HttpRequestResponse;
        //是否主动推送数据的标志位
        this.giveData = true;
        //发送统计参数的地址
        this.vStaUrl = downloadConfig.vStaUrl;
        //分的总块数
        this.totalBlockNum = 0;
        //发送统计的方法
        this.VstaP2P = new sendVplayer();
        //请求种子的MP4地址
        this.seedUrl = '';
        this.trackServerUrl = downloadConfig.mServerInfo;
        //正在播放的块号
        this.playingIndex = 0;
        //是否关闭p2p标志位，关闭p2p请求的情况主要包括创建PeerConnectInfo失败
        this.stopP2PFlag = false;
        // 请求错误的次数
        this.errorNum = 0;
        // 是否显示错误信息标志位
        this.showTestInfo = showTestInfo;
        // 上一次的下载量，给统计的数据用
        this.lastDownloadNum = 0;
        // p2p请求出错技术器
        this.p2pErrorNum = 0;
        // p2p 下载速率
        this.p2pRate = 0;

        let t = this;
        // 是否显示测试信息标志位
        if (showTestInfo && typeof setTestContainer == 'function') {
            // 创建放置测试信息的盒子放置到页面中
            setTestContainer(this);
        }
    }
    /**
     *
     * @param {Object} 初始化参数
     * @param {String} obj.mURL - 视频mp4地址
     * @param {String} obj.mServerInfo - track服务器地址
     * @param {String} obj.seedUrl - 种子视频mp4地址，需要在视频的mp4地址后面加入固定的参数
     * @param {String} obj.trackServerUrl - 请求track服务器地址接口
     * @param {Function} obj.mReturnDataCallback - 返回数据的回调函数
     */
    init(params) {
        for (let i in params) {
            this[i] = params[i];
        }
        bufferSlice();
        // 发送head请求
        this.sendHeadRequest();
        // 请求track服务器地址
        // this.reqTrackServerUrl();
    }
    /**
     * 请求trackserve服务地址
     */
    reqTrackServerUrl() {
        // 请求trackserver服务的地址
        this.httpRequest.sendRequest('get', null, this.trackServerUrl, 3000).then(data => {
            let response = data[2].response;
            let arr = response.split('[/IP]');
            if (arr.length) {
                let ip = arr[0].split('[IP]')[1];
                let port = arr[1].split('[/PORT]')[0].split('[PORT]')[1];
                let httpUrl = 'http://' + ip + ':8081';
                this.mServerInfo = httpUrl;
                // 像服务器发送http请求 请求种子
            }
        });
    }
    /**
     * 请求MP4文件大小并初始化统计对象
     */
    sendHeadRequest() {
        this.httpRequest
            .sendRequest('head', null, this.mURL, 3000)
            .then(data => {
                this.httpRequestCallback(...data);
                this.seedUrl = encodeURIComponent(`${this.mURL}?bs20170421=524288&flen=${this.mSize}`); //种子MP4地址
                // this.seedUrl = encodeURIComponent(
                //     `http://ips.ifeng.com/video19.ifeng.com/video09/2017/11/21/4744099-102-008-0914.mp4?bs20170421=524288&flen=8684225`,
                // );
            })
            .then(data => {
                //初始化统计对象
                let initStaParams = {
                    url: this.mURL,
                    total_block: this.totalBlockNum,
                };
                this.VstaP2P.init(initStaParams, this.vStaUrl); //初始化统计参数
                if (this.showTestInfo && typeof updateTestInfo === 'function') {
                    updateTestInfo(this);
                }
            });
    }
    /**
     * 请求成功之后的处理回调函数
     * @params {String} result - 请求成功、失败、超时状态位
     * @params {String} requestType - 请求类型 head get
     * @params {Object} xmlhttp
     * @params {Int} startPos - 请求开始字节
     * @params {Int} endPos - 请求结束字节
     * @params {String} errorCode - 请求发省错误时的错误码，请求被取消的错误码是0
     */
    httpRequestCallback(result, requestType, xmlhttp, startPos, endPos, errorCode) {
        let nIndex = this.getIndex(startPos || this.mReadPos); // 块号
        //初始化统计参数
        let initStaParams = {
            status: 'success', // 状态
            block_id: nIndex, // 块号
            dl_bytes: parseInt(endPos) - parseInt(startPos) + 1, // 本次下载的字节数
        };

        if (result == this.HttpRequestResponse.RESPONSE_RETURN_SUCCESS) {
            this.errorNum = 0;
            if (requestType == 'head') {
                let size = xmlhttp.getResponseHeader('Content-Length'); // 获取MP4文件长度
                if (size <= 0) {
                    console.log('请求头文件大小值错误，size:', size);
                } else {
                    this.mSize = size;
                    this.splitBlock(); //划分数据块
                    // let startReadPos = this.mReadPos;
                    this.vdnDownload(); // 开启vdn下载数据
                }
            } else if (requestType == 'get') {
                let buf = new Uint8Array(xmlhttp.response);
                if (buf != null || buf != undefined) {
                    console.log(buf.length, this.mDataBlockArray[nIndex].mDataLength, this.mDataBlockArray[nIndex].mDataLength < endPos - startPos);
                    let item = this.mDataBlockArray[nIndex];
                    // 防止拖动的过程中重复点击请求同一块数据，同时返回造成buffer被撑爆
                    if (item.mDataLength < item.mEndPos - item.mStartPos) {
                        item.mData.set(buf, item.mDataLength);
                        item.mDataLength += buf.length;
                        if (this.showTestInfo) {
                            console.log(
                                '收到数据 blockNum:' +
                                    item.mBlockId +
                                    ' 长度：' +
                                    buf.length +
                                    ' startPos:' +
                                    startPos +
                                    'endPos:' +
                                    endPos,
                            );
                        }

                        if (endPos >= item.mEndPos) {
                            // 下载数据完整，从未下载列表中删除
                            this.deleteUnloadBlock(item.mBlockId);
                        }
                        //发送cdn下载成功统计
                        this.VstaP2P.sendCdn(initStaParams);
                        this.mVDNRequesting = false;
                        // 将数据主动推送给video模块
                        if (startPos > item.mStartPos && startPos > this.mReadPos) {
                            buf = new Uint8Array(item.mDataLength);
                            buf.set(item.mData, 0);
                            this.mReturnDataCallback(buf, item.mStartPos);
                        } else {
                            this.mReturnDataCallback(buf, startPos);
                        }
                        // 是否值主动推送数据模式，是更新数据的读取位置
                        if (this.giveData) {
                            this.mReadPos = endPos + 1;
                        }
                        updateTestInfo(this); //todo待删除 更新测试dom
                        // 下载新的模块
                        this.vdnDownload();
                    }
                }
            }
        } else if (result == this.HttpRequestResponse.RESPONSE_RETURN_ERROR) {
            //请求失败
            console.error('请求失败,errorCode:' + errorCode);
            this.mVDNRequesting = false;
            this.errorNum += 1;
            if (this.errorNum < 10) {
                // VDN重新请求
                if (requestType === 'head') {
                    this.sendHeadRequest();
                } else if (requestType === 'get') {
                    //发送失败统计
                    initStaParams.status = 'failed';
                    initStaParams.dl_bytes = 0;
                    this.VstaP2P.sendCdn(initStaParams);
                    this.vdnDownload();
                }
            }
        } else if (result == this.HttpRequestResponse.RESPONSE_NOT_SUPORT_RANGE) {
            //server不支持range
            console.log('server不支持range');
            initStaParams.status = 'failed';
            initStaParams.dl_bytes = 0;
            this.VstaP2P.sendCdn(initStaParams);
            this.mVDNRequesting = false;
        } else if (result == this.HttpRequestResponse.RESPONSE_TIMEOUT) {
            //请求超时
            let strOutInfo = '';
            strOutInfo = '请求超时,请求类型：' + requestType;
            if (requestType == 'get') {
                strOutInfo += ',startPos:' + startPos + ',endPos:' + endPos;
            }
            console.log(strOutInfo);
            this.mVDNRequesting = false;

            // // VDN重新请求
            if (requestType == 'head') {
                this.sendHeadRequest();
            } else if (requestType == 'get') {
                initStaParams.status = 'failed';
                initStaParams.dl_bytes = 0;
                this.VstaP2P.sendCdn(initStaParams);
                this.vdnDownload();
            }
        }
    }
    /**
     * 将MP4划分块 每一块的大小是512k 剩余的加到第一块中，除了第一块所有块的大小均为512k
     */
    splitBlock() {
        let { BLOCK_SIZE } = downloadConfig; // 每一个分块的大小
        let lastSize = this.mSize % BLOCK_SIZE; // 不能整除的剩余块大小
        let blockCount = parseInt(this.mSize / BLOCK_SIZE); // 总共的分块数
        let pos = 0;
        //视频大小小于512K
        if (blockCount == 0 && lastSize != 0) {
            blockCount = 1;
        }
        this.totalBlockNum = blockCount; //视频划分的总块数
        let strOut = `文件大小：${(this.mSize / 1024 / 1024).toFixed(2)}M,平均每块大小${BLOCK_SIZE /
            1024}KB,本视频共分为${blockCount}块,最后一块大小：${lastSize}B`;
        if (this.showTestInfo && document.getElementById('videoInfo')) {
            document.getElementById('videoInfo').innerHTML = `
                <table border="1">
                    <tr>
                        <th>文件大小：</th>
                        <td>${(this.mSize / 1024 / 1024).toFixed(2)}M</td>
                    </tr>
                    <tr>
                        <th>每块大小：</th>
                        <td>${BLOCK_SIZE / 1024}KB</td>
                    </tr>
                    <tr>
                        <th>分块数：</th>
                        <td>${blockCount}块</td>
                    </tr>
                    <tr>
                        <th>第一块的大小为：</th>
                        <td>${lastSize}B</td>
                    </tr>
                </table>`;
        }
        // console.info(strOut);
        for (let i = 0; i < blockCount; i++) {
            let datablock = {};
            datablock.mStartPos = pos;
            datablock.mEndPos = datablock.mStartPos + BLOCK_SIZE - 1;
            if (i == 0) {
                datablock.mEndPos += lastSize;
                if (datablock.mEndPos + 1 > this.mSize) {
                    datablock.mEndPos = this.mSize - 1;
                }
                this.mFirstBlockSize = datablock.mEndPos + 1;
            }
            datablock.mData = new Uint8Array(datablock.mEndPos - datablock.mStartPos + 1);
            datablock.mDataLength = 0; // 已经下载的数据长度
            datablock.mBlockId = i; // 块号

            let block = {};
            block.mBlockId = i;
            block.mStartPos = datablock.mStartPos;
            block.mEndPos = datablock.mEndPos;

            this.mNotDownloadBlockId.push(block);
            this.mDataBlockArray.push(datablock);
            pos = datablock.mEndPos + 1;
        }
    }
    /**
     * 开始从vdn和p2p下载数据
     */
    vdnDownload() {
        console.log('vdnstart', this.mVDNRequesting)
        if (this.mVDNRequesting) {
            return;
        }
        let { INTERVAL_BLOCK_SIZE } = downloadConfig;
        let nReadPos = this.mReadPos; //读取位置
        let nIndex = this.getIndex(nReadPos); //读取开始块位置
        let endIndex = this.getIndex(nReadPos + INTERVAL_BLOCK_SIZE); //读取结束块的位置
        let blockDownload = null;
        let findIndex = 0;

        for (let i = nIndex; i < this.mDataBlockArray.length && i <= endIndex; i++) {
            blockDownload = this.getUnloadBlockInfo(this.mDataBlockArray[i].mBlockId); //查找没有下载的块
            if (blockDownload != null && blockDownload != undefined) {
                findIndex = i;
                break;
            }
        }

        if (blockDownload != null && blockDownload != undefined) {
            // 查询当前块是否在p2p下载,是取消p2p下载
            let p2pDownloadObj = this.mP2PDownloadMap[blockDownload.mBlockId];
            if (p2pDownloadObj) {
                this.cancleP2PDownload(p2pDownloadObj);
            }

            //VDN下载 发送vdn请求
            if (findIndex < this.mDataBlockArray.length) {
                this.mVDNRequesting = true;
                if (this.showTestInfo) {
                    console.log(
                        'VDN Request blockNum=' +
                            this.mDataBlockArray[findIndex].mBlockId +
                            ' start:' +
                            (this.mDataBlockArray[findIndex].mStartPos +
                            this.mDataBlockArray[findIndex].mDataLength) +
                            ' end:' +
                            this.mDataBlockArray[findIndex].mEndPos,
                    );
                }

                this.httpRequest
                    .sendRequest(
                        'get',
                        'arraybuffer',
                        this.mURL,
                        3000,
                        this.mDataBlockArray[findIndex].mStartPos + this.mDataBlockArray[findIndex].mDataLength,
                        this.mDataBlockArray[findIndex].mEndPos,
                    )
                    .then(data => {
                        this.httpRequestCallback(...data);
                    });
            }
        }

        //取消p2p下载，即将被VDN下载
        for (let key in this.mP2PDownloadMap) {
            if (key < endIndex + 1) {
                this.cancleP2PDownload(this.mP2PDownloadMap[key]);
            }
        }
        // 开启新的P2P下载
        // 开启新的P2P下载
        if (!this.stopP2PFlag) {
            this.createP2PDownload();
        }
    }
    /**
     * 获取所在位置的块号
     * @params {Int} pos - 位置
     */
    getIndex(pos) {
        let nIndex = 0;
        if (pos < this.mFirstBlockSize) {
            nIndex = 0;
        } else {
            nIndex = parseInt((pos - this.mFirstBlockSize) / downloadConfig.BLOCK_SIZE) + 1;
        }
        if (nIndex >= this.mDataBlockArray.length) {
            nIndex = this.mDataBlockArray.length - 1;
        }
        return nIndex;
    }
    /**
     * 查找指定块是否已经下载
     * @params {Int} blockId - 块id
     */
    getUnloadBlockInfo(blockId) {
        let blockDownload = null;
        for (let i = 0; i < this.mNotDownloadBlockId.length; i++) {
            if (this.mNotDownloadBlockId[i].mBlockId == blockId) {
                blockDownload = this.mNotDownloadBlockId[i];
                break;
            }
        }
        return blockDownload;
    }
    /**
     * 块下载完成，将块从没有下载的队列中删除
     * @params {String} blockId - 块id
     */
    deleteUnloadBlock(blockId) {
        for (let i = 0; i < this.mNotDownloadBlockId.length; i++) {
            if (this.mNotDownloadBlockId[i].mBlockId == blockId) {
                this.mNotDownloadBlockId.splice(i, 1);
                break;
            }
        }
    }
    /**
     * 开启新的p2p下载
     */
    createP2PDownload() {
        let { P2P_DOWNLOAD_COUNT } = downloadConfig;
        if (this.showTestInfo) {
            console.log('上次创建的p2p的最大索引数', this.mP2PDownloadBlockMaxNum);
        }

        if (this.mDataBlockArray.length > 0) {
            if (this.mP2PDownloadBlockMaxNum == this.mDataBlockArray[this.mDataBlockArray.length - 1].mBlockId) {
                this.mP2PDownloadBlockMaxNum = 0;
            }
        }

        let maxBlockNum = this.mP2PDownloadBlockMaxNum;
        let nCount = 0;
        //正在下载的p2p的个数
        for (let key in this.mP2PDownloadMap) {
            nCount++;
        }
        maxBlockNum = parseInt(maxBlockNum) + 1;
        let nReadPos = this.mReadPos;
        let { INTERVAL_BLOCK_SIZE } = downloadConfig;
        let endIndex = this.getIndex(nReadPos + INTERVAL_BLOCK_SIZE);
        if (this.showTestInfo) {
            console.log('上次读取位置', endIndex);
        }
        let nIndex = this.mDataBlockArray.length;

        //数据块id在范围内，并且数据块没有被下载
        for (let i = endIndex + 1; i < this.mDataBlockArray.length; i++) {
            if (
                maxBlockNum <= this.mDataBlockArray[i].mBlockId &&
                this.mDataBlockArray[i].mDataLength <
                    this.mDataBlockArray[i].mEndPos - this.mDataBlockArray[i].mStartPos + 1 &&
                !this.mP2PDownloadMap[i]
            ) {
                // if (this.showTestInfo) {
                //     console.log(
                //         i,
                //         this.mDataBlockArray[i].mDataLength,
                //         this.mDataBlockArray[i].mEndPos - this.mDataBlockArray[i].mStartPos + 1,
                //     );
                // }
                nIndex = i;
                break;
            }
        }
        // for(let i = maxBlockNum; i < this.mDataBlockArray.length; i++){
        // 	if (maxBlockNum <= this.mDataBlockArray[i].mBlockId && this.mDataBlockArray[i].mDataLength < this.mDataBlockArray[i].mEndPos - this.mDataBlockArray[i].mStartPos + 1) {
        // 		nIndex = i;
        // 		break;
        // 	}
        // }
        //剩余可创建的p2p链接的个数
        if (this.showTestInfo) {
            console.info('创建p2p之前信息', maxBlockNum, nIndex);
        }

        for (let i = P2P_DOWNLOAD_COUNT - nCount; i > 0; i--) {
            if (nIndex >= this.mDataBlockArray.length || this.mNotDownloadBlockId.length < 1) {
                break;
            }

            let p2pDownloadObj = new P2PDownload();

            this.mDataBlockArray[nIndex].peertrying = true; //todo待删除
            updateTestInfo(this); //todo待删除 更新测试dom

            this.mP2PDownloadMap[this.mDataBlockArray[nIndex].mBlockId] = p2pDownloadObj;
            if (this.showTestInfo) {
                console.info('创建p2p', nIndex, this.mP2PDownloadMap);
                console.log('createP2PDownload BlockId:' + this.mDataBlockArray[nIndex].mBlockId);
            }
            this.mP2PDownloadBlockMaxNum = this.mDataBlockArray[nIndex].mBlockId;
            p2pDownloadObj.setDownloadInfo(this, nIndex);
            nIndex++;
        }
    }
    /**
     * 取消正在下载的p2p
     */
    cancleP2PDownload(p2pDownloadObj) {
        if (p2pDownloadObj != null && p2pDownloadObj != undefined) {
            if (this.showTestInfo) {
                console.log('cancleP2PDownload BlockId:' + p2pDownloadObj.mBlockId, this.mP2PDownloadMap);
            }
            delete this.mP2PDownloadMap[p2pDownloadObj.mBlockId]; // 从map中删除正在下载的p2p的id
            // 取消p2p下载
            p2pDownloadObj.cancleDownload();
            this.copyP2PDownloadData(p2pDownloadObj);

            this.mDataBlockArray[p2pDownloadObj.mBlockId].peertrying = false; //todo待删除
            updateTestInfo(this); //todo待删除

            p2pDownloadObj = null;
        }
    }
    /**
     * 拷贝已经下载的数据
     */
    copyP2PDownloadData(p2pDownloadObj) {
        if (p2pDownloadObj != null && p2pDownloadObj != undefined) {
            // 拷贝已下载数据
            let buf = p2pDownloadObj.getData();
            if (buf != null && buf != undefined && buf.length > 0) {
                if (this.showTestInfo) {
                    console.log('P2P下载数据长度', buf.length);
                }
                this.mDataBlockArray[p2pDownloadObj.mBlockId].mData.set(buf, 0);
                this.mDataBlockArray[p2pDownloadObj.mBlockId].mDataLength = buf.length;
                this.mDataBlockArray[p2pDownloadObj.mBlockId].P2PDataLength = buf.length; //todo待删除
            }
        }
    }
    /**
     * P2P下载完成回调
     */
    p2pRecvFinishCallback(blockId) {
        let p2pDownloadObj = this.mP2PDownloadMap[blockId];
        if (p2pDownloadObj != null && p2pDownloadObj != undefined) {
            if (this.showTestInfo) {
                console.error('finish===>' + blockId, this.mP2PDownloadMap, this.mDataBlockArray[blockId].mStartPos);
            }
            this.deleteUnloadBlock(blockId);
            this.cancleP2PDownload(p2pDownloadObj);
            // 开启新的P2P下载
            this.createP2PDownload();
            //发送统计
            let initStaParams = {
                status: 'success',
                block_id: blockId,
                dl_bytes:
                    parseInt(this.mDataBlockArray[blockId].mEndPos) -
                    parseInt(this.mDataBlockArray[blockId].mStartPos) +
                    1,
            };
            this.VstaP2P.sendP2p(initStaParams);
            //推送数据
            this.mReturnDataCallback(p2pDownloadObj.getData(), this.mDataBlockArray[blockId].mStartPos);
            p2pDownloadObj = null;
            this.mDataBlockArray[blockId].peertrying = false; //todo待删除
            updateTestInfo(this); //todo待删除
        }
    }
    /**
     * P2P下载出错，新建p2p
     */
    p2pCreateNew(blockId) {
        let p2pDownloadObj = this.mP2PDownloadMap[blockId];
        if (p2pDownloadObj) {
            //发送统计
            let buf = p2pDownloadObj.getData();
            let initStaParams = {
                status: 'failed',
                block_id: blockId,
                dl_bytes: buf ? buf.length : 0,
            };
            this.VstaP2P.sendP2p(initStaParams);
        } else {
            //发送统计
            let initStaParams = {
                status: 'failed',
                block_id: blockId,
                dl_bytes: 0,
            };
            this.VstaP2P.sendP2p(initStaParams);
        }

        this.cancleP2PDownload(p2pDownloadObj);
        p2pDownloadObj = null;

        this.mDataBlockArray[blockId].peertrying = false; //todo待删除
        updateTestInfo(this); //todo待删除

        // 开启新的P2P下载
        this.createP2PDownload();
    }
    /**
     * seek数据 video控制台
     */
    seek(pos) {
        console.log('请求位置：' + pos);
        if (this.mSize <= 0) {
            this.mReadPos = pos;
            return;
        }
        if (pos >= this.mSize) {
            pos = this.mSize;
        }

        window.clearTimeout(this.readDataTimer);

        this.mReadPos = pos;
        //取消VDN下载
        this.httpRequest.stop();

        this.mVDNRequesting = false;
        this.giveData = true;
        if (this.mReturnDataCallback != null && this.mReturnDataCallback != undefined) {
            let nIndex = this.mReadPos;
            let buf = this.getData();
            if (buf != null && buf != undefined && buf.length > 0) {
                console.log('ReturnDataCallback=======');
                this.mReturnDataCallback(buf, nIndex);
                // console.log("mReadPos:"+downloadObj.mReadPos+",buf.length:"+buf.length+",writePos:"+writePos)
                // bufTemp.set(buf, writePos);
                // writePos += buf.length;
            }
        }
        //this.vdnDownload();
        //this.readDataTimer = setTimeout(timeCallback(this), 500);
    }
    /**
     * 从下载数据队列中取数据，开始位置为上次的读取位置
     */
    getData() {
        let { INTERVAL_BLOCK_SIZE } = downloadConfig;
        let buf = null;
        // 读取位置大于视频的长度,返回null
        if (this.mReadPos + 1 >= this.mSize) {
            return buf;
        }
        let readPos = this.mReadPos + INTERVAL_BLOCK_SIZE - 1;
        //数据块小于512kb
        if (readPos >= this.mSize) {
            readPos = this.mSize - 1;
        }

        let nIndex = this.getIndex(this.mReadPos); // 读取块开始的位置
        let nEndIndex = this.getIndex(readPos); // 读取结束块的位置

        let retLength = 0;
        let readEndIndex = nEndIndex;
        for (let i = nIndex; i <= nEndIndex; i++) {
            if (
                this.mDataBlockArray[i].mDataLength <
                this.mDataBlockArray[i].mEndPos - this.mDataBlockArray[i].mStartPos
            ) {
                let downloadDataPos = this.mDataBlockArray[i].mStartPos + this.mDataBlockArray[i].mDataLength;
                if (downloadDataPos < readPos) {
                    readPos = downloadDataPos;
                }
                readEndIndex = i;
                break;
            }
        }
        console.log('从buffer中获取数据', nIndex, nEndIndex, '下载可以吐得数据块位置：', readEndIndex);
        retLength = readPos - this.mReadPos;
        if (readPos != 0) {
            retLength += 1;
        }

        if (retLength > 0) {
            buf = new Uint8Array(retLength);
        } else {
            this.vdnDownload();
            return buf;
        }

        let pos = 0;
        for (let i = nIndex; i <= readEndIndex; i++) {
            let startPos = 0;
            let endPos = 0;
            // 向外读取数据，读取开始块和结束块需要特殊处理，开始块的读取开始的位置不一定是0，结束块的位置不一定是数据块结束的位置（可能没下载完）
            if (i == nIndex) {
                //console.log("getData start mReadPos:" + this.mReadPos);
                startPos = this.mReadPos - this.mDataBlockArray[i].mStartPos;
            }
            if (i == readEndIndex) {
                endPos = readPos - this.mDataBlockArray[i].mStartPos;
            } else {
                endPos = this.mDataBlockArray[i].mEndPos - this.mDataBlockArray[i].mStartPos;
            }
            let buftemp = this.mDataBlockArray[i].mData.slice(startPos, endPos + 1);
            console.log(
                'getData blockId:' + this.mDataBlockArray[i].mBlockId + ' start:' + startPos + ' end:' + endPos,
            );
            buf.set(buftemp, pos);
            pos += endPos - startPos + 1;
        }

        console.log("getData end length:" + buf.length);
        this.mReadPos += retLength;
        //判断是否小于vdn间隔
        this.vdnDownload();
        return buf;
    }
    /**
     * video获取数据的接口，
     * @params {Int} pos 需要读取的开始的字节的位置
     */
    getDataInterface(pos) {
        console.error('video模块请求getDataInterface,请求位置', this.getIndex(pos), pos, this.mSize);
        this.mReadPos = pos;
        if (this.mReturnDataCallback != null && this.mReturnDataCallback != undefined) {
            let nIndex = this.mReadPos;
            let buf = this.getData();
            if (buf != null && buf != undefined && buf.length > 0) {
                console.log('ReturnDataCallback=======');
                this.mReturnDataCallback(buf, nIndex);
            }
        }
    }
    /**
     * 取消vdn和p2p下载
     */
    pause() {
        //取消VDN下载
        this.httpRequest.stop();
        this.mVDNRequesting = false;
        // 取消p2p下载
        for (let key in this.mP2PDownloadMap) {
            this.cancleP2PDownload(this.mP2PDownloadMap[key]);
        }
    }
    /**
     * video播放是更新播放位置，测试用
     */
    updatePlayingTest(pos) {
        let index = this.getIndex(parseInt(pos * this.mSize));
        this.playingIndex = index;
        showPlaying(this.playingIndex);
    }
    /**
     * 停止vdn的主动下载
     */
    stopVndDownAuto() {
        //取消VDN下载
        // this.httpRequest.stop();
        // this.mVDNRequesting = false;
        this.giveData = false;
    }
    /**
     * 停止p2p下载
     */
    stopP2P(blockId) {
        this.stopP2PFlag = true;
        let p2pDownloadObj = this.mP2PDownloadMap[blockId];
        if (p2pDownloadObj) {
            //发送统计
            let buf = p2pDownloadObj.getData();
            let initStaParams = {
                status: 'failed',
                block_id: blockId,
                dl_bytes: buf ? buf.length : 0,
            };
            this.VstaP2P.sendP2p(initStaParams);
        } else {
            //发送统计
            let initStaParams = {
                status: 'failed',
                block_id: blockId,
                dl_bytes: 0,
            };
            this.VstaP2P.sendP2p(initStaParams);
        }

        this.cancleP2PDownload(p2pDownloadObj);
        p2pDownloadObj = null;
    }
}

export default downloadModel;



// WEBPACK FOOTER //
// ./components/f.component.mediasource/app/modules/DownloadModel.js